import { Controller } from "@hotwired/stimulus";

// Staff top bar (staffnav#1): dropdown groups + phone menu button.
//
// Root = <nav data-controller="nav-dropdown">; every group is a <details data-nav-dropdown-target="group">.
// - opening one group closes the others
// - click outside the nav and Esc close the open group (Esc returns focus to its <summary>)
// - burger (phone) toggles .is-menu-open on the root and mirrors it in aria-expanded
export default class extends Controller {
  static targets = ["group", "burger"];

  connect() {
    this._outside = (e) => {
      if (!this.element.contains(e.target)) this.#closeAll();
    };
    this._keydown = (e) => {
      if (e.key !== "Escape") return;
      const open = this.groupTargets.find((g) => g.open);
      if (!open) return;
      open.open = false;
      open.querySelector("summary")?.focus();
    };
    this._toggle = (e) => {
      if (!e.target.open) return;
      this.groupTargets.forEach((g) => {
        if (g !== e.target) g.open = false;
      });
    };
    document.addEventListener("click", this._outside);
    document.addEventListener("keydown", this._keydown);
    this.groupTargets.forEach((g) => g.addEventListener("toggle", this._toggle));
  }

  disconnect() {
    document.removeEventListener("click", this._outside);
    document.removeEventListener("keydown", this._keydown);
    this.groupTargets.forEach((g) => g.removeEventListener("toggle", this._toggle));
  }

  toggleMenu() {
    const open = this.element.classList.toggle("is-menu-open");
    if (this.hasBurgerTarget) {
      this.burgerTarget.setAttribute("aria-expanded", String(open));
    }
  }

  #closeAll() {
    this.groupTargets.forEach((g) => {
      g.open = false;
    });
  }
}
